// extracted by mini-css-extract-plugin
export default {"emptyCenter":"_3T-43","title":"_1yBtj","subtitle":"_8rUhJ"};